import { css, unsafeCSS } from 'lit';

/** Colors of the info table cells (td[data-color]); the names are OmegaGrid color types. */
export const CELL_COLORS = ['green', 'red', 'yellow', 'gray'] as const;
export type CellColor = typeof CELL_COLORS[number];

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
		min-width: 300px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	td:first-child {
		text-align: right;
	}

	td.description {
		text-align: left;
	}

	td, th {
		border-right: 1px solid var(--og-border-color);
		border-bottom: 1px solid var(--og-border-color);
		width: 50%;
		padding: 4px;
	}

	tr:last-child td {
		border-bottom: none;
	}

	${unsafeCSS(CELL_COLORS.map(color => `
	td[data-color="${color}"] {
		background-color: var(--og-colortype-${color}-background-color);
		color: var(--og-colortype-${color}-text-color);
	}`).join('\n'))}

	.outcome {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		vertical-align: middle;
	}

	og-button {
		text-align: center;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}

	.header .job-info {
		display: flex;
		align-items: center;
		min-width: 0;
		flex: 1;
		gap: 4px;
	}

	.header .job-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		min-width: 0;
		flex: 1;
		width: 1px;
		font-weight: bold;
	}

	.header .job-icon {
		display: flex;
		flex-shrink: 0;
	}

	.body .job-buttons {
		display: flex;
		gap: 4px;
	}

	.body .job-buttons .action {
		flex: 1;
	}

	#timer {
		text-align: right;
		flex-shrink: 0;
	}
`;
